import React from 'react';
import {
  DownsampledIndicator,
  LowResolutionIndicator
} from 'app/components/flowRateSampleIndicators/DataResolutionIndicators';

const DataResolutionIndicator = ({
  dataResolution,
  avgConfiguredSamplingRate,
  useConfiguredSamplingRate = false,
  interactive = false
}) => {
  // Only use avgConfiguredSamplingRate logic when explicitly requested (for Avg Configured Sampling Rate row)
  if (useConfiguredSamplingRate && avgConfiguredSamplingRate && avgConfiguredSamplingRate !== 'N/A') {
    // Parse the sampling rate (e.g., "1:2.5" -> 2.5)
    const parseSamplingRate = (rateString) => {
      const match = rateString.match(/^1:(\d+(?:\.\d+)?)$/);
      return match ? parseFloat(match[1]) : null;
    };

    const samplingRatio = parseSamplingRate(avgConfiguredSamplingRate);
    if (samplingRatio && samplingRatio > 1) {
      if (samplingRatio > 2) {
        return <LowResolutionIndicator interactive={interactive} />;
      }

      return <DownsampledIndicator interactive={interactive} />;
    }
    return null;
  }

  // Use dataResolution logic (for Data Resolution row)
  if (dataResolution === 'low') {
    return <LowResolutionIndicator interactive={interactive} />;
  }

  if (dataResolution === 'downsampled') {
    return <DownsampledIndicator interactive={interactive} />;
  }

  // For 'ok' or any other value, don't display anything
  return null;
};

export default DataResolutionIndicator;
